import "./App.css";
import About from "./pages/About";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <div className="container-xxl bg-white p-0">
      <Routes>
        <Route path="/" element={<><Home /></>} />
        <Route path="/about" element={<><About /></>} />
        <Route path="/services" element={<><Services /></>} />
        <Route path="/contact" element={<><Contact /></>} />
      </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
